import "./css/custom.css";
import React, { useEffect } from "react";
import './css/app.css';
// import ProtectedRoute from './components/ProtectedRoute';
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { addRecaptchaScript, addTWAKScript } from "./utils";
import { AuthProvider } from "./contexts/AuthContext";
import { AppRouter } from "./Router";
import { setAxiosInstance } from "./api/httpClient";
import TopLoadingBar from "./components/LoadingBar";

const App = () => {
  useEffect(() => {
    addRecaptchaScript();
    if (!window.location.pathname.includes("/questions")) {
      addTWAKScript();
    }
  }, []);

  setAxiosInstance({
    baseURL: process.env.REACT_APP_API_URL,
  })

  // if (isLoading) {
  //   return <Loader />;
  // }

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthProvider>
          <TopLoadingBar />
          <AppRouter />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
